import React from 'react';
import Grid from '@material-ui/core/Grid';
import PlatformInfoTable from './Components/PlatformInfoTable';


export default function PlatformInfo() {

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
                <PlatformInfoTable />
            </Grid>
        </Grid>
    );
}